/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
import Media from "react-media";

import { Desktop, Mobile } from "../layout/Layout";
import Gettext from "../common/Gettext";
import { IronRedesignThemeProvider } from "../ThemeProvider";

const Button = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  vertical-align: middle;
  margin-left: 29px;
  margin-right: 14px;
  padding-right: 14px;
  color: ${({ theme }) => theme.staticHeaderLink};
  background-color: transparent;
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;

  :hover,
  :focus,
  :active {
    color: ${props => props.theme.accent};
  }

  @media (max-width: 959px) {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    width: ${({ trade }) => (trade === true ? "48px" : "auto")};
    height: ${({ trade }) => (trade === true ? "48px" : "auto")};
    margin-left: 0;
    margin-right: ${({ trade }) => (trade === true ? 0 : "14px")};
    padding-right: 0;
    font-size: 24px;

    :hover,
    :focus,
    :active {
      color: ${({ theme }) => theme.staticHeaderLink};
    }

    ${props =>
      !props.trade &&
      css`
        margin-right: 5px;
      `};
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.accent};
    `};
`;

const IconContainer = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 36px;
  height: 16px;

  @media (max-width: 959px) {
    width: 26px;
    height: 12px;
  }
`;

function Icon() {
  return (
    <Media query="(min-width: 960px)">
      {matches =>
        matches ? (
          <IconContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="625.885 3407 16 16"
              width="16"
              height="16"
              fill="currentColor"
            >
              <path
                d="M0,370v-2c0-2.2,3.6-4,8-4s8,1.8,8,4v2Zm4-12a4,4,0,1,1,4,4A4,4,0,0,1,4,358Z"
                transform="translate(625.885 3053)"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="645 3409 16 14"
              width="16"
              height="14"
              fill="currentColor"
            >
              <path
                d="M-6160,14V12h10v2Zm0-6V6h16V8Zm0-6V0h16V2Z"
                transform="translate(6805 3409)"
              />
            </svg>
          </IconContainer>
        ) : (
          <IconContainer>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="-2382.067 2864.3 25.019 11.4"
              width="26"
              height="12"
              fill="currentColor"
            >
              <g transform="translate(-2382.067 2864.3)">
                <path
                  d="M-6160,9.975V8.549h7.125V9.975Zm0-4.275V4.275h11.4V5.7Zm0-4.275V0h11.4V1.425Z"
                  transform="translate(6173.619 1.425)"
                />
                <path
                  d="M0,365.4v-1.425c0-1.568,2.565-2.85,5.7-2.85s5.7,1.282,5.7,2.85V365.4Zm2.85-8.549A2.85,2.85,0,1,1,5.7,359.7,2.85,2.85,0,0,1,2.85,356.85Z"
                  transform="translate(0 -354)"
                />
              </g>
            </svg>
          </IconContainer>
        )
      }
    </Media>
  );
}

type Props = {
  onClick: (key?: boolean) => void,
  active: boolean,
  isIOS: boolean,
  trade?: boolean,
  className?: string,
  icon?: React.Node,
  userId: number
};

function ToggleNav(props: Props) {
  if (props.isIOS) {
    return (
      <Button
        as="a"
        role="button"
        href="ios://toggle_menu"
        active={props.active}
        trade={props.trade}
        onClick={props.onClick}
        className={props.className}
      >
        {props.icon || <Icon />}
      </Button>
    );
  }

  const ABTest = props.userId % 2;

  return (
    <IronRedesignThemeProvider>
      {ABTest ? (
        <React.Fragment>
          <Desktop>
            <Button
              role="button"
              onClick={() => props.onClick(true)}
              active={props.active}
              trade={props.trade}
              className={props.className}
            >
              <div style={{ marginRight: 5, textTransform: "uppercase" }}>
                <Gettext>Menu</Gettext>
              </div>
              <div>{props.icon || <Icon />}</div>
            </Button>
          </Desktop>
          <Mobile>
            <Button
              role="button"
              onClick={props.onClick}
              active={props.active}
              trade={props.trade}
              className={props.className}
            >
              {props.icon || <Icon />}
            </Button>
          </Mobile>
        </React.Fragment>
      ) : (
        <Button
          role="button"
          onClick={props.onClick}
          active={props.active}
          trade={props.trade}
          className={props.className}
        >
          {props.icon || <Icon />}
        </Button>
      )}
    </IronRedesignThemeProvider>
  );
}

export default ToggleNav;



// WEBPACK FOOTER //
// ./src/components/Navigation/Hamburger.js